module.exports = __webpack_public_path__ + "static/media/PY.65a6caf2.svg";